const review = {
  title: 'Kako vam se sviđa aplikacija?',
  starHint: '1 = ne sviđa se, 5 = jako sviđa',
  commentPlaceholder: 'Prijedlozi za poboljšanja (opcionalno)',
  submit: 'Pošalji',
};

export default review;
